import React from 'react';

import * as S from './style';

function Section({ children, className, ...props }) {
  return (
    <S.SectionWrapper className={className} {...props}>
      {children}
    </S.SectionWrapper>
  );
}

Section.S = S;

export { Section };
